<template>
  <div class="wrapper">
    <FORM  ref="childForm"  @formclick="formclick" :formData="formData"></FORM>
    <table-page ref="childTable"  :pageData="pageData"></table-page>
  </div>
</template>

<script>
  //table封装组件
  import tablePage from '@/components/page/table.vue'
  import FORM from '@/components/page/form.vue'
  import DateUtil from '@/utils/IM/tradeDataUtil'
  import Url from '@/views/crs36/util/url'
  export default {
    name: 'activeblacklist',
    components: {
      tablePage,
      FORM,
    },
    methods: {
      /*表格按钮点击事件*/
      bthClick (clickName, row) {
        if (clickName == "update"){
          this.$refs.childUpdate.open(row);
        }
      },
      /*查询表单按钮点击事件*/
      formclick(clickName, data){
        if("查询" == clickName || window.$t('crs36.bt.search') == clickName){
          this.queryData = data;
          this.$refs.childTable.defaultGetData(data);
        }
      },
    },
    data () {
      return {
        queryData:{},
        /*from查询表单*/
        formData:{
          hasLable: true,
          cols:[
              { title: window.$t('crs36.active.activeNo'), field: 'activeNo'},
              { title: window.$t('crs36.active.userList'), field: 'userList'},
              { click: window.$t('crs36.bt.search')}
          ]
        },
        /*table生成*/
        pageData: {
          queryUrl: Url.active.black.qurey, //请求路径和参数
          sequence: true,
          cols: [
              { title: window.$t('crs36.active.activeNo'), field: 'activeNo'},
              { title: window.$t('crs36.active.userList'), field: 'userList'},
              { title: window.$t('crs36.common.creator'), field: 'creator'},
              { title: window.$t('crs36.common.createTime'), field: 'createTime',render:(data,full)=>{
                      return DateUtil.formatDate(data,"yyyy-MM-dd hh:mm:ss");
                  }},
          ]
        }
      }
    }
  }
</script>
